function getItemSurcharge(item, surchargeKey) {
	if (!item?.surcharge || !surchargeKey) {
		return 0;
	}

	return parseFloat(item[`surcharge${surchargeKey}`]) || 0;
}

function formatPrice(amount) {
	return `$${amount.toFixed(2)}`;
}

export function cakePriceCalculator() {
	const display = document.getElementById('cake-price-display');

	if (!display) {
		return;
	}

	const pricing = JSON.parse(display.dataset.pricing);
	const form = display.closest('form');

	if (!form) {
		return;
	}

	function getSelectedValue(name) {
		const input = form.querySelector(`input[name="${name}"]:checked`);

		return input ? input.value : null;
	}

	function getSelectedValuesFromCheckboxSet(prefix) {
		const inputs = form.querySelectorAll(`input[name^="${prefix}["][type="checkbox"]:checked`);
		return Array.from(inputs).map(i => i.value);
	}

	function getQuantity() {
		const input = form.querySelector('input[name="Quantity"]');

		return input ? parseInt(input.value, 10) || 1 : 1;
	}

	function getFixedPrice(surchargeKey) {
		if (!surchargeKey || !pricing.fixedPrices) {
			return 0;
		}

		return parseFloat(pricing.fixedPrices[surchargeKey]) || 0;
	}

	function calculate() {
		const sizeId = getSelectedValue('CakeSizeID');

		if (!sizeId || !pricing.sizes[sizeId]) {
			display.textContent = 'Total: (select all options above to see price)';
			return;
		}

		const size = pricing.sizes[sizeId];
		let unitPrice = 0;

		if (pricing.isFlavored) {
			unitPrice = getFixedPrice(size.surchargeKey);

			if (pricing.doubleLayer) {
				const size2Id = getSelectedValue('CakeSize2ID');

				if (size2Id && pricing.sizes[size2Id]) {
					unitPrice += getFixedPrice(pricing.sizes[size2Id].surchargeKey);
				}
			}
		} else {
			unitPrice = size.price + pricing.designSurcharge;

			if (pricing.doubleLayer) {
				const size2Id = getSelectedValue('CakeSize2ID');

				if (size2Id && pricing.sizes[size2Id]) {
					unitPrice += pricing.sizes[size2Id].price;
				}
			}

			if (pricing.isCustom) {
				const baseId = getSelectedValue('CakeBaseID');
				const fillingIds = getSelectedValuesFromCheckboxSet('CakeFillings');

				if (baseId && pricing.bases[baseId]) {
					unitPrice += getItemSurcharge(pricing.bases[baseId], size.surchargeKey);
				}

				// If multiple fillings have a surcharge, only apply the highest
				let maxFillingSurcharge = 0;
				for (const fillingId of fillingIds) {
					if (fillingId && pricing.fillings[fillingId]) {
						const surcharge = getItemSurcharge(pricing.fillings[fillingId], size.surchargeKey);
						maxFillingSurcharge = Math.max(maxFillingSurcharge, surcharge);
					}
				}
				unitPrice += maxFillingSurcharge;
			}
		}

		const total = unitPrice * getQuantity();

		display.textContent = `Total: ${formatPrice(total)}`;
	}

	form.addEventListener('change', calculate);
	calculate();
}
